import { httpService, HttpTask } from '@core/http';
import { Sensoterra } from '@modules/sensors/sensoterra/model';

export namespace SensoterraService {
  const URI = '/iot/sensoterra';

  export function getParameters(): HttpTask<Array<Sensoterra.Parameter>> {
    return httpService.get(`${URI}/parameters`);
  }
}
